import { Linkedin, Mail } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-secondary/50 py-12">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center gap-6 mb-8">
          <div className="text-3xl font-bold">
            {t("footer.name").split(" ").slice(0, 3).join(" ")} <span className="text-primary">{t("footer.name").split(" ").slice(3).join(" ")}</span>
          </div>
          <p className="text-muted-foreground">{t("footer.subtitle")}</p>
          
          <div className="flex gap-4">
            <a
              href="https://www.linkedin.com/in/paulo-sem-fronteiras/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn profile"
              className="w-12 h-12 bg-card rounded-full flex items-center justify-center hover:bg-primary/20 transition-colors border border-primary/20 hover:border-primary"
            >
              <Linkedin className="h-5 w-5" />
            </a>
            <a
              href="mailto:paulodasilva233@gmail.com"
              aria-label="Send email"
              className="w-12 h-12 bg-card rounded-full flex items-center justify-center hover:bg-primary/20 transition-colors border border-primary/20 hover:border-primary"
            >
              <Mail className="h-5 w-5" />
            </a>
          </div>
        </div>
        
        <div className="pt-8 border-t border-border text-center text-sm text-muted-foreground">
          <p>&copy; 2024 {t("footer.name")}. {t("footer.rights")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
